var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appName == 'senso')?_c('PrivacyPolicySenso'):_c('PrivacyPolicyImprove')}
var staticRenderFns = []

export { render, staticRenderFns }